import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

//--NOTE: Add tests for this service
@Injectable()
export class StepNavigationService {
	constructor(private router: Router) { }

	public getCurrentPathIndex(routes: any[]): number {
		const routeIndex = routes.findIndex(path => this.router.url.includes(path.route));
		return routeIndex;
	}
}
